export default {
  // Use this development config if you're running services locally
  // development: {
  //   baseUrl: 'http://localhost',
  //   clientId: 'LGhBgGZmTx6iG9IIOQL4og',
  // },
  // Use the below development config if pointing at stage
  // You'll have to redirect to qa, then manually copy the code in the url
  // This is a Zoom limitation with no programmatic workaround
  development: {
    baseUrl: 'https://qa.zola.com',
    clientId: '7fXWMxYeQp2Ahi87TVXmmA',
  },
  staging: {
    baseUrl: 'https://qa.zola.com',
    clientId: '7fXWMxYeQp2Ahi87TVXmmA',
  },
  production: {
    baseUrl: 'https://www.zola.com',
    clientId: 'Wdavt6RrSdW67t8_4tz_Jg',
  },
};



// WEBPACK FOOTER //
// ./src/util/zoomConfig.js